import React from 'react';
import './TextInput.css';

type Props = {
  value: string;
  name: string;
  type?: string;
  label?: string;
  ariaLabel?: string;
  desc?: string;
  placeholder?: string;
  errorMessage?: string;
  disabled?: boolean;
  className?: string;
  onChange: (e: any) => void;
  onKeyDown?: (e: any) => void;
};

const TextInput: React.FC<Props> = ({
  value,
  name,
  type,
  label,
  ariaLabel,
  desc,
  placeholder,
  errorMessage,
  disabled,
  className,
  onChange,
  onKeyDown,
}) => {
  return (
    <div className={`TextInput ${className ? className : ''}`}>
      {label !== '' && label !== 'undefined' ? (
        <span className='pm-input-label'>{label}</span>
      ) : null}
      {desc !== '' && desc !== 'undefined' ? (
        <span className='pm-input-desc'>{desc}</span>
      ) : null}
      <input
        value={value}
        name={name}
        aria-label={ariaLabel ? ariaLabel : undefined}
        type={type}
        placeholder={placeholder !== undefined ? placeholder : ''}
        disabled={disabled}
        onChange={onChange}
        required
        onKeyDown={onKeyDown ? onKeyDown : undefined}
        className={`pm-input ${
          errorMessage !== '' && errorMessage !== undefined
            ? 'invalid-input'
            : ''
        }`}
      />
      {errorMessage !== '' && errorMessage !== undefined ? (
        <span className='invalid-input-message'>{errorMessage}</span>
      ) : null}
    </div>
  );
};

export default TextInput;
